import { render, staticRenderFns } from "./WizardProgress.vue?vue&type=template&id=9c4d4a10&scoped=true"
import script from "./WizardProgress.vue?vue&type=script&lang=js"
export * from "./WizardProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4d4a10",
  null
  
)

export default component.exports